import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3a826a2d")

_pushScopeId("data-v-3a826a2d")
const _hoisted_1 = { class: "title" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = { class: "infomation" }
const _hoisted_4 = { class: "label-info" }
const _hoisted_5 = { class: "infomation" }
const _hoisted_6 = { class: "label-info" }
const _hoisted_7 = { class: "infomation" }
const _hoisted_8 = { class: "label-info vertical-align-top" }
const _hoisted_9 = { class: "label-info" }
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = { class: "infomation" }
const _hoisted_13 = { class: "label-info" }
const _hoisted_14 = { class: "infomation" }
const _hoisted_15 = { class: "label-info" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_billing_dialog = _resolveComponent("billing-dialog")
  const _component_billing_dialog_ins = _resolveComponent("billing-dialog-ins")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$wordList.BillTitle) + "     ", 1),
      _createVNode("i", {
        style: {"cursor":"pointer"},
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowBill = true)),
        class: "el-icon-my-modify"
      })
    ]),
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$wordList.BillInHtmlBillingTitle), 1),
      _createVNode("label", null, _toDisplayString(_ctx.billInfo.BillingTitle), 1)
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$wordList.TabelBillATTN), 1),
      _createVNode("label", null, _toDisplayString(_ctx.billInfo.Contactor), 1)
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$wordList.BillInHtmlAddress), 1),
      _createVNode("label", _hoisted_9, [
        _createTextVNode(_toDisplayString(_ctx.billInfo.Street), 1),
        _hoisted_10,
        _createTextVNode(_toDisplayString(_ctx.billInfo.Postcode) + " " + _toDisplayString(_ctx.billInfo.City), 1),
        _hoisted_11,
        _createTextVNode(_toDisplayString(_ctx.billInfo.Country), 1)
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$wordList.TabelBillTEL), 1),
      _createVNode("label", null, _toDisplayString(_ctx.billInfo.TelePhone), 1)
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$wordList.TabelBillFax), 1),
      _createVNode("label", null, _toDisplayString(_ctx.billInfo.Fax), 1)
    ]),
    (_ctx.showBillingDialog(_ctx.isShowBill,_ctx.userType) == '1')
      ? (_openBlock(), _createBlock(_component_billing_dialog, {
          key: 0,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowBill = false)),
          onSuccess: _ctx.getMsg,
          userType: _ctx.userType
        }, null, 8, ["onSuccess", "userType"]))
      : _createCommentVNode("", true),
    (_ctx.showBillingDialog(_ctx.isShowBill,_ctx.userType) == '2')
      ? (_openBlock(), _createBlock(_component_billing_dialog_ins, {
          key: 1,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowBill = false)),
          onSuccess: _ctx.getMsg,
          userType: _ctx.userType
        }, null, 8, ["onSuccess", "userType"]))
      : _createCommentVNode("", true)
  ]))
})